import { permissionsSet } from "Recoil/LoggedInUserDetail/selector";
import { useRecoilValue } from "recoil";

export const useRoleAndPermission = () => {
  const permissions = useRecoilValue(permissionsSet);
  const handlePendingUserPermission = () => {
    const pendingUsers = permissions?.pendingUsers;
    return (
      (pendingUsers?.writeAccess ||
        pendingUsers?.modifyAccess ||
        pendingUsers?.deleteAccess) &&
      pendingUsers?.readAccess
    );
  };

  return {
    handlePendingUserPermission,
  };
};
